import { useLocation } from "react-router-dom";
import {
  TYPE_ALIPAY,
  TYPE_CASH,
  TYPE_CUP,
  TYPE_JCB,
  TYPE_MASTERCARD,
  TYPE_PAYPAL,
  TYPE_PROMPAY,
  TYPE_TRUEMONEY,
  TYPE_VISA,
  TYPE_WECHAT,
} from "../../../utils/useConstants";
import {
  ICON_ALIPAY,
  ICON_CASH,
  ICON_CUP,
  ICON_JCB,
  ICON_MASTERCARD,
  ICON_PAYPAL,
  ICON_PROMPAY,
  ICON_TRUEMONEY,
  ICON_VISA,
} from "../../../utils/useIcons";
import { useIsMobile } from "../../../utils/useIsMobile";

export const OrderGetPaymentImageMain = ({ input, row }) => {
  const isMobile = useIsMobile();
  if (input === TYPE_VISA) {
    return (
      <ICON_VISA
        className={` w-10 md:w-[42px] mr-1 ${isMobile ? " mb-[1px] " : ""}`}
      />
    );
  } else if (input === TYPE_MASTERCARD) {
    return (
      <ICON_MASTERCARD className={` w-9  ${isMobile ? " mb-[2px] " : "  "}`} />
    );
  } else if (input === TYPE_CASH) {
    return (
      <ICON_CASH className={` w-7 mr-1  ${isMobile ? " mb-[2px] " : "  "}`} />
    );
  } else if (input === TYPE_CUP) {
    return (
      <ICON_CUP className={`w-[24px] mr-1 ${isMobile ? " mb-[px] " : "  "}`} />
    );
  } else if (input === TYPE_PROMPAY) {
    return (
      <ICON_PROMPAY
        className={`w-[18px] mr-1 ${isMobile ? " mb-[2px] " : "  "}`}
      />
    );
  } else if (input === TYPE_JCB) {
    return <ICON_JCB className="  " />;
  } else if (input === TYPE_PAYPAL) {
    return <ICON_PAYPAL className="  " />;
  } else if (input === TYPE_ALIPAY) {
    return <ICON_ALIPAY className="  " />;
  } else if (input === TYPE_TRUEMONEY) {
    return <ICON_TRUEMONEY className="  " />;
  } else {
    return <ICON_CASH className=" w-7 mr-1 mb-[2px]" />;
  }
};

export const OrderGetPaymentImage = ({ input, row }) => {
  if (input === TYPE_VISA) {
    return <ICON_VISA className={` w-10 md:w-[42px] mr-1 mb-[2px]`} />;
  } else if (input === TYPE_MASTERCARD) {
    return <ICON_MASTERCARD className=" w-9 mb-[2px]" />;
  } else if (input === TYPE_CASH) {
    return <ICON_CASH className=" w-7 mr-1 mb-[2px]" />;
  } else if (input === TYPE_CUP) {
    return <ICON_CUP className=" w-7 mr-1 mb-[2px]" />;
  } else if (input === TYPE_PROMPAY) {
    return <ICON_PROMPAY className="w-[18px] mr-1 mb-[2px]" />;
  } else if (input === TYPE_JCB) {
    return <ICON_JCB className="  mr-1  mb-[2px]  " />;
  } else if (input === TYPE_PAYPAL) {
    return <ICON_PAYPAL className="  mr-1  " />;
  } else if (input === TYPE_ALIPAY) {
    return <ICON_ALIPAY className="  mr-1  mb-[2px]  " />;
  } else if (input === TYPE_TRUEMONEY) {
    return <ICON_TRUEMONEY className="  mr-1   mb-[2px]  " />;
  } else {
    return <ICON_CASH className=" w-7 mr-1 mb-[2px]" />;
  }
};

export default OrderGetPaymentImage;
